import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { rem } from 'polished';
import { FlexRow } from '../../Defaults/Flexbox/Flexbox';

export interface Props {
  children: any;
  fromTop: number;
}

function NavigationDropdownContent({ children, fromTop }: Props) {
  return <DropdownContent fromTop={fromTop}>{children}</DropdownContent>;
}

const DropdownContent = styled(FlexRow)`
  position: absolute;
  top: auto;
  bottom: 0;
  z-index: -1;
  width: 100%;
  width: calc(100% + (2 * ${rem(40)}));
  margin-left: ${rem(-40)};
  box-shadow: ${({ theme }) => theme.boxShadow.default};

  @media (max-width: ${rem(1550)}) {
    width: 100%;
    margin-left: 0;
  }

  &:hover {
    display: block;
  }
`;

export { NavigationDropdownContent as CorporateNavigationDropdownContent };
